import State from '../../components/Stats/State'
import type RemoteService from './RemoteService'

export interface LeetcodeStats {
  totalSolved: number
  totalEasy: number
  totalMedium: number
  totalHard: number
}

export class LeetcodeService implements RemoteService<LeetcodeStats> {
  readonly queryKey = 'LeetcodeService'
  private state: State = State.NOT_STARTED
  private stats: LeetcodeStats

  private static LEETCODE_URL = 'https://leetcode-stats.tashif.codes/fabasoad'

  public constructor(defaultVal: LeetcodeStats) {
    this.stats = defaultVal
  }

  public async request(): Promise<LeetcodeStats> {
    if (this.state !== State.FINISHED && this.state !== State.STARTED) {
      this.state = State.STARTED
      try {
        const resp: Response = await fetch(LeetcodeService.LEETCODE_URL)
        const { totalSolved, totalEasy, totalMedium, totalHard } = await resp.json()
        this.state = State.FINISHED
        this.stats = { totalSolved, totalEasy, totalMedium, totalHard }
      } catch (err) {
        this.state = State.FAILED
      }
    }
    return this.stats
  }
}
